import { render, staticRenderFns } from "./VideoFilePopup.vue?vue&type=template&id=6f651b82&scoped=true&"
import script from "./VideoFilePopup.vue?vue&type=script&lang=js&"
export * from "./VideoFilePopup.vue?vue&type=script&lang=js&"
import style0 from "./VideoFilePopup.vue?vue&type=style&index=0&id=6f651b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f651b82",
  null
  
)

export default component.exports